import { render, staticRenderFns } from "./WalletWithdrawDetailItem.vue?vue&type=template&id=6f2449bc&scoped=true&"
import script from "./WalletWithdrawDetailItem.vue?vue&type=script&lang=js&"
export * from "./WalletWithdrawDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./WalletWithdrawDetailItem.vue?vue&type=style&index=0&id=6f2449bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2449bc",
  null
  
)

export default component.exports